const initialState = {
    data: [],
    page: 1,
    total: 0,
    alreadyMounted: false,
};

function expensesReducer(state = initialState, action) {
    let nextState;
    switch (action.type) {
        case "SET_EXPENSES_DATA":
            nextState = {
                ...state,
                data: action.value,
            };
            return nextState || state;
        case "SET_EXPENSES_PAGE":
            nextState = {
                ...state,
                page: action.value,
            };
            return nextState || state;
        case "SET_EXPENSES_TOTAL":
            nextState = {
                ...state,
                total: action.value,
            };
            return nextState || state;
        case "SET_EXPENSES_ALREADY_MOUNTED":
            nextState = {
                ...state,
                alreadyMounted: action.value,
            };
            return nextState || state;
        default:
            return state;
    }
}

export default expensesReducer;